export enum ApiEnum {
  AUTH = 'auth',
  USERS = 'users',
  STATS = 'stats',
  PLAY = 'play',
  INDEX = 'index',
  SEARCH = 'search'
}
